/**
 * The draft transcript has to already be Latin. ElevenLabs often hears Urdu
 * as Devanagari, and replacing that line later makes the words change.
 * Same letter map as the Django transliterator.
 */
const DEVANAGARI = /[\u0900-\u097F]/;

const INDEPENDENT = {
  अ: "a", आ: "aa", इ: "i", ई: "ee", उ: "u", ऊ: "oo",
  ए: "e", ऐ: "ai", ओ: "o", औ: "au", ऑ: "o", ऋ: "ri",
};
const MATRA = {
  "ा": "a", "ि": "i", "ी": "ee", "ु": "u", "ू": "oo",
  "े": "e", "ै": "ai", "ो": "o", "ौ": "au", "ॉ": "o", "ृ": "ri",
};
const CONSONANT = {
  क: "k", ख: "kh", ग: "g", घ: "gh", ङ: "ng",
  च: "ch", छ: "chh", ज: "j", झ: "jh", ञ: "ny",
  ट: "t", ठ: "th", ड: "d", ढ: "dh", ण: "n",
  त: "t", थ: "th", द: "d", ध: "dh", न: "n",
  प: "p", फ: "ph", ब: "b", भ: "bh", म: "m",
  य: "y", र: "r", ल: "l", व: "w", श: "sh",
  ष: "sh", स: "s", ह: "h",
  "क़": "q", "ख़": "kh", "ग़": "gh", "ज़": "z", "फ़": "f", "ड़": "r", "ढ़": "rh",
};
const NUKTA = { क: "q", ख: "kh", ग: "gh", ज: "z", फ: "f", ड: "r", ढ: "rh" };
const DIGIT = Object.fromEntries([..."०१२३४५६७८९"].map((ch, n) => [ch, String(n)]));
const HALANT = "्";
const NUKTA_MARK = "़";

function transliterate(text) {
  const chars = [...text];
  const out = [];
  let i = 0;
  while (i < chars.length) {
    const ch = chars[i];
    if (DIGIT[ch]) {
      out.push(DIGIT[ch]);
      i += 1;
      continue;
    }
    if (INDEPENDENT[ch]) {
      out.push(INDEPENDENT[ch]);
      i += 1;
      continue;
    }
    let base = null;
    if (CONSONANT[ch] && chars[i + 1] === NUKTA_MARK) {
      base = NUKTA[ch] || CONSONANT[ch];
      i += 2;
    } else if (CONSONANT[ch]) {
      base = CONSONANT[ch];
      i += 1;
    }
    if (!base) {
      out.push(ch === "।" ? "." : ch);
      i += 1;
      continue;
    }
    if (chars[i] === HALANT) {
      out.push(base);
      i += 1;
      continue;
    }
    if (MATRA[chars[i]]) {
      out.push(base + MATRA[chars[i]]);
      i += 1;
    } else {
      out.push(`${base}a`);
    }
    if (chars[i] === "ं" || chars[i] === "ँ") {
      out.push("n");
      i += 1;
    }
  }
  return out.join("").replace(/\s+/g, " ").trim();
}

export function romanDraft(text) {
  const value = String(text || "").trim();
  if (!value || !DEVANAGARI.test(value)) return value;
  return transliterate(value);
}
